import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({ variables, palette, breakpoints }) => ({
  courierPromotionContent:{
    width:'864px',
    [breakpoints.down('sm')]: {
      width:'680px'
    },
    [breakpoints.down('xs')]: {
      width:'100%',
      flexDirection: 'column',
      paddingLeft:variables?.spacingE,
      paddingRight:variables?.spacingE,
      height:'auto'
    },
    height:'328px',
    margin:'0 auto',
    display:'flex',
    '& .title-icon': {
      color: palette.jet?.supportBrand01,
      fontWeight:'bold !important',
      marginRight: `${variables?.spacingB}`,
    },
    '& .courierpromotion-title':{
      marginBottom:variables?.spacingE
    },
    '& .courierpromotion-description':{ 
      width:'566px',
      [breakpoints.down('sm')]: {
        width:'500px'
      },
      [breakpoints.down('xs')]: {
        width:'unset'
      },
      marginBottom:variables?.spacingE
    },
    '& .courierpromotion-side-section-1': {
      paddingTop:variables?.spacingF,
      width:'685px',
      [breakpoints.down('xs')]: {
        width:'100%'
      },
      '& .title-holder': {
        display:'flex', 
        alignItems:'center'
      },
      '& .image-holder': {
        width:'181px',
        margin:`${variables?.spacingNone} auto`,
        position:'relative'
      },
      '& .phone-image-mobile-view':{ 
        height:'328px'
      },
      '& .courier-promotion-animation': {
        position:'absolute',
        height:'276px',
        width:'119px',
        marginTop:'25px',
        marginLeft:'31px',
        borderRadius:'14px',
        transform:'perspective(500px) rotateY(-8deg)'
     }
    },
    '& .courierpromotion-side-section-2': {
       '& .courier-promotion-animation-bg': {
        height:'328px'
       },
       '& .courier-promotion-animation': {
          position:'absolute',
          height:'276px',
          width:'119px',
          marginTop:'25px',
          marginLeft:'31px',
          borderRadius:'14px',
          transform:'perspective(500px) rotateY(-8deg)'
       }
    },
    '& .articles':{
      marginTop:variables?.spacingG,
      paddingLeft:variables?.spacingNone,
      listStyle:'none',
      '& li':{
        marginBottom:variables?.spacingE,
        "& p": {
          position:'relative',
          paddingLeft:variables?.spacingF 
        },
        "& .jetFontIcon": {
          position:'absolute',
          left:variables?.spacingNone,
          top:`-${variables?.spacingA}`
        }
      },
      '& .article-icon': {
        color:palette?.jet?.supportPositiveInverse,
        position:'relative',
        marginRight:variables?.spacingC
      }
    }
  },
}));

export default useStyles;
